import { createTheme } from '@mui/material/styles';

const commonSettings = {
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
    ].join(','),
  },
  components: {
    MuiButton: {
      defaultProps: {
        size: 'small',
      },
    },
    MuiTextField: {
      defaultProps: {
        size: 'small',
      },
    },
    // Add other common component defaults here if needed
  },
};

// Light theme based on the original theme
export const lightTheme = createTheme({
  ...commonSettings,
  palette: {
    mode: 'light',
    primary: {
      main: '#1976d2', // Original primary color
    },
    secondary: {
      main: '#dc004e', // Original secondary color
    },
    background: {
      default: '#f5f5f5', // Standard light background
      paper: '#ffffff',   // Standard light paper background
    },
    text: {
      primary: 'rgba(0, 0, 0, 0.87)', // Standard light text
      secondary: 'rgba(0, 0, 0, 0.6)',
    }
  },
});

// Dark theme definition
export const darkTheme = createTheme({
  ...commonSettings,
  palette: {
    mode: 'dark',
    primary: {
      main: '#90caf9', // Lighter blue for dark mode contrast
    },
    secondary: {
      main: '#f48fb1', // Lighter pink/red for dark mode contrast
    },
    background: {
      default: '#121212', // Standard dark background
      paper: '#1e1e1e',   // Standard dark paper background
    },
    text: {
      primary: '#ffffff', // Standard dark text
      secondary: 'rgba(255, 255, 255, 0.7)',
    }
  },
});

// We no longer export a single default theme
// export default theme;
